import React from 'react';
import { createHashHistory } from 'history';
import ic_dico from '../img/ic_dico.jpg';
import arrows from "../img/ic_back.png";
import "../css/Home.css";
const history = createHashHistory();
const Dico = () => {
  const backHome = () => {
    history.push("/");
  }
  return (
    <div style={{ position: "relative" }}>
      <img style={{ width: '100%' }} src={ic_dico} alt='img' />
      <div style={{ position: "absolute", zIndex:2, right: "50px", top: '50px' }} className="logoW" onClick={backHome}>
        <div className="logowText" style={{color: '#fff'}}>WENGOLD</div>
        <div className="logowImgBack">
          <img src={arrows} alt="logo" />
        </div>
      </div>
    </div>

  )
}

export default Dico